import { formatDayPartsForMessage } from 'experiments/deeplinks-flow-feature/treatment/features/menu/utils/is-entry-out-of-active-day-parts';
import type { DayPartUnavailableKind } from 'experiments/deeplinks-flow-feature/treatment/features/menu/utils/is-entry-out-of-active-day-parts';
import { t } from 'state/intl/translations';

const MESSAGE_KEYS = {
  item: 'itemOnlyAvailableOnDayParts',
  category: 'categoryOnlyAvailableOnDayParts',
  menu: 'menuOnlyAvailableOnDayParts',
} as const;

export function getDayPartUnavailableMessage(
  kind: DayPartUnavailableKind,
  dayParts: readonly string[]
): string {
  const formatted = formatDayPartsForMessage(dayParts);
  if (!formatted) {
    return t('incentiveFeedbackOutOfDayPart');
  }
  return t(MESSAGE_KEYS[kind], { dayParts: formatted });
}
